import request from '../utils/http'
// 版本列表
export function index (query) {
  return request({
    url: '/upgrade/list',
    method: 'GET',
    params: query
  })
}
// 新增
export function save (query) {
  return request({
    url: '/upgrade/save',
    method: 'POST',
    data: query
  })
}
// 编辑
export function edit (query) {
  return request({
    url: '/upgrade/edit',
    method: 'GET',
    params: query
  })
}
// 更新
export function update (query) {
  return request({
    url: '/upgrade/update',
    method: 'POST',
    data: query
  })
}
// 用户开关
export function show (query) {
  return request({
    url: '/upgrade/show',
    method: 'POST',
    params: query
  })
}
// 删除版本
export function del (query) {
  return request({
    url: '/upgrade/delete',
    method: 'DELETE',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/upgrade.js